

import CreateRoutes from '../router'
import Header from '../components/Header'

import './App.css';

export default function App() {
    return (
        <div>
            <Header/>
            <CreateRoutes/>
        </div>
    )
}